import { graphql } from "@/lib/gql/__generated__/gql";

export const OptionNewItem_EditPage_Query = graphql(`
	query OptionNewItem($hotelID: ID!, $duplicateOptionID: ID) {
		optionNewItem(hotelID: $hotelID, duplicateOptionID: $duplicateOptionID) {
			id
			hotelID
			optionID
			inSale
			isNotDiscountTarget
			maxStockNum
			availablePlanIDs
			soldNumTotal
			maxDailyStockNum
			billingTypeTerm
			billingTypeTarget
			price {
				currencyType
				amount
			}
			name
			description
			isNextMorning
			cancelPolicy {
				beforeDays
				chargeRatio
			}
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
				isHolidayStayable
			saleStartBeforeDate
			requiredPrepMillisecond
			maxBuyableNumPerTarget
			minimumBuyableNumPerTarget
			useAsSubOption
			multiSubOptionSelectable
			isDateTabbedTimeSelectionEnabled
			optionType
			subOptions {
				subOptionID
				name
				startAt
				endAt
				isNextMorning
				memo
				maxDailyStockNum
				isShowTimeSchedule
				price {
					currencyType
					amount
				}
			}
		}
		hotelPolicy(hotelID: $hotelID) {
			cancelPolicy {
				beforeDays
				chargeRatio
			}
		}
		hotelPolicy(hotelID: $hotelID) {
			requiredPrepMillisecond
		}
		planList(hotelID: $hotelID) {
			plans {
				planID
				name
				id
			}
			secrets {
				planID
				id
				name
			}
		}
		discountList(hotelID: $hotelID) {
			id
			ordinary {
				discountID
				id
				name
				hotelID
				isOptionDiscountEligible
			}
		}
	}
`);
